import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TermsAndConditionsSection from './sections/TermsAndConditionsSection';

type Props = {}

const TermsAndConditions = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");

  return (
    <>
      <Header title={t("termsAndConditions.title")} includeBreadcrumbs />
      <ModuleContent>
        <TermsAndConditionsSection />
      </ModuleContent>
    </>
  )
}

export default TermsAndConditions;